<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-12-22 17:22:32
 * @FilePath: \mrc-base-frontend\src\views\app_version_manage\add\index.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-23 10:44:26
-->
<template>
  <Info />
</template>

<script>
import Info from "../modules/info.vue";
export default {
  components: { Info },
  props: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {},
};
</script>

<style scoped></style>
